<template>
    <span>
        <vue-folder-button
                :text="likeButtonText"
                :color="likeButtonColor"
                tabindex="0"
                @mousedown.stop.native="toggleLike"
                icon-class="fa-heart"
                ref="likeButton"
                @mouseenter.native="showLikePopoverWithDelay"
                @mouseleave.native="cancelShowLikePopover"
                v-touch:touchhold="showLikePopover"
        >
            <span slot="text" v-html="likeButtonText"></span>
        </vue-folder-button>
        <Popover
                v-if="popoverReady"
                custom-class="like-button-popover"
                ref="likeButtonPopover"
                title="Liked by:"
                trigger="manual"
                placement="bottom"
                :target="$refs.likeButton"
                v-model="likePopoverOpened"
                tabindex="0"
        >
            <template slot="popover">
                <div>
                    <simple-link
                            :target="likedUser"
                            v-for="likedUser in entry.liked_users_sample"
                            :key="likedUser.id"
                    >
                        <span
                                class="liked-users-sample"
                                :style="getLikedUserSampleStyle(likedUser)"
                                v-tooltip="likedUser.name"
                        ></span>
                    </simple-link>
                </div>
                <div class="text-right" v-if="entry.likes_count>5">
                    <span class="text-right color-tag-gray-dark pointer" @click="showWhoLiked"
                    >Show more</span>
                </div>
            </template>
        </Popover>
    </span>
</template>

<script>
    import {CurrentUserClass} from "shared/CurrentUser";
    import Vue from "vue";
    import * as _ from "lodash";

    export default {
        name: "LikeWithPopover",
        props: {
            initialEntry: Object,
            likesEntryPoint: Object,
        },
        data() {
            return {
                entry: {
                },

                likePopoverOpened: false,
                popoverReady: false,
                isTouchDevise: false,
            };
        },
        computed: {
            likeButtonText() {
                if (this.entry?.likes_count) {
                    return this.entry.likes_count + '';
                } else {
                    return '&nbsp;';
                }
            },
            likeButtonColor() {
                if (this.entry?.liked_by_me) {
                    return 'red';
                } else {
                    return 'tag-gray';
                }
            },

        },
        methods: {
            toggleLike() {
                if (!new CurrentUserClass().is_authenticated()) {
                    return;
                }
                const likesEntryPoint = this.likesEntryPoint;

                let increase = 1;
                let resource = likesEntryPoint.like;
                let message = 'You liked the post';
                if (this.entry.liked_by_me) {
                    increase = -1;
                    resource = likesEntryPoint.unlike;
                    message = 'You unliked the post';
                }

                this.entry.liked_by_me = !this.entry.liked_by_me;
                this.entry.likes_count += increase;
                resource(this.entry.id)
                    .then(r => {
                            Vue.notifications.success(message);
                            this.entry.likes_count = r.data.likes_count;
                            const CurrentUser = new CurrentUserClass();
                            if (increase === 1) {
                                if (this.entry.liked_users_sample?.length < 5) {

                                    this.entry.liked_users_sample.push({
                                        avatar: CurrentUser.avatar,
                                        name: CurrentUser.name,
                                        id: CurrentUser.id,
                                        link: CurrentUser.link,
                                    });
                                }
                            } else {
                                this.entry.liked_users_sample = this.entry.liked_users_sample.filter(u => u.id !== CurrentUser.id);
                                if(!this.entry.liked_users_sample.length){
                                    this.cancelShowLikePopover();
                                    this.hideLikePopover();
                                }
                            }
                        },
                        err => {
                            Vue.notifications.error(err || 'Error');
                            this.entry.liked_by_me = !this.entry.liked_by_me;
                            this.entry.likes_count -= increase;
                        }
                    );
            },
            getLikedUserSampleStyle(user) {
                return {
                    'background-image': `url('${user.avatar}')`
                };
            },
            showLikePopoverWithDelay() {
                if (this.isTouchDevise) {
                    return;
                }
                this.showLikePopoverTimeout = setTimeout(() => this.showLikePopover(), 300);
            },
            cancelShowLikePopover() {
                if (this.showLikePopoverTimeout !== undefined) {
                    clearTimeout(this.showLikePopoverTimeout);
                    this.showLikePopoverTimeout = undefined;
                }
            },
            showLikePopover() {
                if (!this.entry?.likes_count) {
                    return;
                }
                this.likePopoverOpened = true;
                const isElementInside = (el) => {
                    while (el.parentNode) {
                        if (el.parentNode === this.$refs.likeButton.$el) {
                            return true;
                        }
                        if (el.parentNode.className && el.parentNode.className.indexOf('like-button-popover') !== -1) {
                            return true;
                        }
                        el = el.parentNode;
                    }
                    return false;
                };


                let lastEvent = undefined;
                const updateLastPointerPosition = (event) => {
                    lastEvent = event;
                };
                const pointerCheckInterval = setInterval(() => {
                    checkWherePointerIs(lastEvent);
                }, 3000);

                const checkWherePointerIs = (event) => {
                    if (!event) {
                        return;
                    }
                    const x = event.clientX, y = event.clientY;
                    const elementMouseIsOver = document.elementFromPoint(x, y);
                    if (isElementInside(elementMouseIsOver)) {
                    } else {
                        this.likePopoverOpened = false;
                        clearInterval(pointerCheckInterval);
                        document.removeEventListener('mousemove', updateLastPointerPosition);
                        document.removeEventListener('scroll', onScroll);
                    }
                };

                const onScroll = () => {
                    this.likePopoverOpened = false;
                    document.removeEventListener('mousemove', updateLastPointerPosition);
                    document.removeEventListener('scroll', onScroll);
                    if (pointerCheckInterval !== undefined) {
                        clearInterval(pointerCheckInterval);
                    }
                };

                // const updateLastPointerPosition = _.throttle(checkWherePointerIs, 100, {leading: false});
                document.addEventListener('mousemove', updateLastPointerPosition);
                document.addEventListener('scroll', onScroll);
            },
            hideLikePopover() {
                this.likePopoverOpened = false;
            },
            showWhoLiked() {
                this.likePopoverOpened = false;

                const likesEntryPoint = this.likesEntryPoint;
                const selectFactory = Vue.getAngularModule('selectFactory');
                selectFactory.endpoint_selector(_.partial(likesEntryPoint.get_liked_users, this.entry.id), false, {
                    button_no: 'Close',
                    button_yes: false,
                    info: false,
                    disable_search: true,
                    list_mode: true,
                    header: 'Likes',
                    empty: 'There are not any likes yet',
                });
            },
        },
        created() {
            this.entry = Object.assign({}, this.initialEntry);
        },
        mounted() {
            setTimeout(() => {
                this.popoverReady = true;
            }, 2000);
            this.isTouchDevise = 'ontouchstart' in window ||
                window.DocumentTouch && document instanceof window.DocumentTouch ||
                navigator.maxTouchPoints > 0 ||
                window.navigator.msMaxTouchPoints > 0;
        }
    };
</script>

<style scoped lang="scss">
  .liked-users-sample {
    display: inline-block;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    margin: 2px;
    width: 40px;
    height: 40px;
  }
</style>
